import React from "react";
import NavBar from "../navbar";
import { Helmet } from "react-helmet";
import Footer from "../footer";
import { useTranslation } from "react-i18next";

const AppTemplate = ({
  pageTitle,
  parentTitle,
  navbar,
  footer,
  absoluteNavbar,
  children,
  footerBackgroundColor,
}) => {
  const { t } = useTranslation();
  const appName = "Naqsh Platform";

  return (
    <div>
      {pageTitle && (
        <Helmet>
          <title>
            {parentTitle
              ? t(parentTitle) + " "
              : t(pageTitle) + " | " + t(appName)}
          </title>
        </Helmet>
      )}
      {navbar && (
        <div className="navbar-content">
          <NavBar absoluteNavbar={absoluteNavbar} />
        </div>
      )}
      {children}
      {footer && <Footer backgroundColor={footerBackgroundColor} />}
    </div>
  );
};

export default AppTemplate;
